/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GlobalOntologyWriteSerializerWithRepr } from '../models/GlobalOntologyWriteSerializerWithRepr';
import type { OntologyLanguageRead } from '../models/OntologyLanguageRead';
import type { OntologyLanguageWriteSerializerWithRepr } from '../models/OntologyLanguageWriteSerializerWithRepr';
import type { OntologyRead } from '../models/OntologyRead';
import type { PaginatedGlobalOntologyWriteSerializerWithReprList } from '../models/PaginatedGlobalOntologyWriteSerializerWithReprList';
import type { PaginatedOntologyLanguageListList } from '../models/PaginatedOntologyLanguageListList';
import type { PaginatedOntologyLanguageWriteSerializerWithReprList } from '../models/PaginatedOntologyLanguageWriteSerializerWithReprList';
import type { PaginatedOntologyListList } from '../models/PaginatedOntologyListList';
import type { PatchedGlobalOntologyWriteSerializerWithRepr } from '../models/PatchedGlobalOntologyWriteSerializerWithRepr';
import type { PatchedOntologyLanguageWriteSerializerWithRepr } from '../models/PatchedOntologyLanguageWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OntologiesService {
    /**
     * @returns PaginatedOntologyListList
     * @throws ApiError
     */
    public static ontologiesList({
        excludeFields,
        fields,
        flowConfig,
        flowConfigIsnull,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        excludeFields?: Array<string>,
        fields?: Array<string>,
        flowConfig?: Array<string>,
        flowConfigIsnull?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedOntologyListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ontologies/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'flow_config': flowConfig,
                'flow_config__isnull': flowConfigIsnull,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns GlobalOntologyWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesCreate({
        requestBody,
    }: {
        requestBody: GlobalOntologyWriteSerializerWithRepr,
    }): CancelablePromise<GlobalOntologyWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ontologies/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedGlobalOntologyWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ontologyBulkUpdate({
        requestBody,
        excludeFields,
        fields,
        flowConfig,
        flowConfigIsnull,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<GlobalOntologyWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        flowConfig?: Array<string>,
        flowConfigIsnull?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedGlobalOntologyWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ontologies/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'flow_config': flowConfig,
                'flow_config__isnull': flowConfigIsnull,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedGlobalOntologyWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ontologyBulkPartialUpdate({
        requestBody,
        excludeFields,
        fields,
        flowConfig,
        flowConfigIsnull,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<GlobalOntologyWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        flowConfig?: Array<string>,
        flowConfigIsnull?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedGlobalOntologyWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/ontologies/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'flow_config': flowConfig,
                'flow_config__isnull': flowConfigIsnull,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ontologyBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ontologies/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns PaginatedOntologyLanguageListList
     * @throws ApiError
     */
    public static ontologiesLanguagesList({
        ontologyPk,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ontology,
        ordering,
        readDepth,
        search,
        utterance,
    }: {
        ontologyPk: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        ontology?: Array<string>,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        utterance?: Array<string>,
    }): CancelablePromise<PaginatedOntologyLanguageListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ontologies/{ontology_pk}/languages/',
            path: {
                'ontology_pk': ontologyPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ontology': ontology,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'utterance': utterance,
            },
        });
    }
    /**
     * @returns OntologyLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesLanguagesCreate({
        ontologyPk,
        requestBody,
    }: {
        ontologyPk: number,
        requestBody: OntologyLanguageWriteSerializerWithRepr,
    }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ontologies/{ontology_pk}/languages/',
            path: {
                'ontology_pk': ontologyPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedOntologyLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ontologyLanguageBulkUpdate({
        ontologyPk,
        requestBody,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ontology,
        ordering,
        readDepth,
        search,
        utterance,
    }: {
        ontologyPk: number,
        requestBody: Array<OntologyLanguageWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        ontology?: Array<string>,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        utterance?: Array<string>,
    }): CancelablePromise<PaginatedOntologyLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ontologies/{ontology_pk}/languages/',
            path: {
                'ontology_pk': ontologyPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ontology': ontology,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'utterance': utterance,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedOntologyLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ontologyLanguageBulkPartialUpdate({
        ontologyPk,
        requestBody,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ontology,
        ordering,
        readDepth,
        search,
        utterance,
    }: {
        ontologyPk: number,
        requestBody: Array<OntologyLanguageWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        ontology?: Array<string>,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        utterance?: Array<string>,
    }): CancelablePromise<PaginatedOntologyLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/ontologies/{ontology_pk}/languages/',
            path: {
                'ontology_pk': ontologyPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ontology': ontology,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'utterance': utterance,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ontologyLanguageBulkDestroy({
        ontologyPk,
        id,
    }: {
        ontologyPk: number,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ontologies/{ontology_pk}/languages/',
            path: {
                'ontology_pk': ontologyPk,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns OntologyLanguageRead
     * @throws ApiError
     */
    public static ontologiesLanguagesRetrieve({
        id,
        ontologyPk,
        excludeFields,
        fields,
        language,
        ontology,
        readDepth,
        utterance,
    }: {
        /**
         * A unique integer value identifying this ontology language.
         */
        id: number,
        ontologyPk: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        ontology?: Array<string>,
        readDepth?: number,
        utterance?: Array<string>,
    }): CancelablePromise<OntologyLanguageRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ontologies/{ontology_pk}/languages/{id}/',
            path: {
                'id': id,
                'ontology_pk': ontologyPk,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'ontology': ontology,
                'read_depth': readDepth,
                'utterance': utterance,
            },
        });
    }
    /**
     * @returns OntologyLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesLanguagesUpdate({
        id,
        ontologyPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this ontology language.
         */
        id: number,
        ontologyPk: number,
        requestBody: OntologyLanguageWriteSerializerWithRepr,
    }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ontologies/{ontology_pk}/languages/{id}/',
            path: {
                'id': id,
                'ontology_pk': ontologyPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OntologyLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesLanguagesPartialUpdate({
        id,
        ontologyPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this ontology language.
         */
        id: number,
        ontologyPk: number,
        requestBody?: PatchedOntologyLanguageWriteSerializerWithRepr,
    }): CancelablePromise<OntologyLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/ontologies/{ontology_pk}/languages/{id}/',
            path: {
                'id': id,
                'ontology_pk': ontologyPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ontologiesLanguagesDestroy({
        id,
        ontologyPk,
    }: {
        /**
         * A unique integer value identifying this ontology language.
         */
        id: number,
        ontologyPk: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ontologies/{ontology_pk}/languages/{id}/',
            path: {
                'id': id,
                'ontology_pk': ontologyPk,
            },
        });
    }
    /**
     * @returns OntologyRead
     * @throws ApiError
     */
    public static ontologiesRetrieve({
        id,
        excludeFields,
        fields,
        flowConfig,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this ontology.
         */
        id: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        flowConfig?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<OntologyRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ontologies/{id}/',
            path: {
                'id': id,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'flow_config': flowConfig,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns GlobalOntologyWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this ontology.
         */
        id: number,
        requestBody: GlobalOntologyWriteSerializerWithRepr,
    }): CancelablePromise<GlobalOntologyWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ontologies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GlobalOntologyWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ontologiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this ontology.
         */
        id: number,
        requestBody?: PatchedGlobalOntologyWriteSerializerWithRepr,
    }): CancelablePromise<GlobalOntologyWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/ontologies/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ontologiesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this ontology.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ontologies/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
